// Lightweight i18n - 3 languages: IT, EN, FR
export const translations = {
  it: {
    nav: { home: "Home", bb: "B&B", casa: "Casa Vacanze", tours: "Tour", contact: "Contatti", book: "Prenota -10%" },
    hero: {
      eyebrow: "Lusso Accessibile · Via dei Tribunali, Napoli",
      title: "I Maestri",
      subtitle: "Due dimore d'autore nel cuore di Napoli. Un B&B di carattere al terzo piano e una casa vacanze raffinata al primo. Tour esclusivi di Napoli e delle Costiere inclusi.",
      cta1: "Scopri il B&B",
      cta2: "Casa dei Maestri",
      scroll: "scorri per esplorare"
    },
    intro: {
      label: "La nostra filosofia",
      title: "Il lusso che ti aspettavi. Il prezzo che non ti aspettavi.",
      body: "Situati nel cuore pulsante di Napoli, lungo il Decumano Maggiore, il B&B I Maestri e la Casa dei Maestri occupano lo stesso storico palazzo di Via dei Tribunali 257. A pochi passi dalle opere d'arte più importanti della città — la Cappella Sansevero con il Cristo Velato, San Gregorio Armeno, il Duomo, Spaccanapoli — e dalle pizzerie e trattorie più celebri al mondo. Due esperienze diverse con la stessa anima: design curato, comfort moderno e accoglienza autentica napoletana.",
      bodyExtra: "Più di un soggiorno: un viaggio nella conoscenza. Ogni camera è dedicata a un grande pensatore — Platone, Buddha, Seneca, Giordano Bruno — e ogni dettaglio, citazione e simbolo invita alla scoperta. Tra arte, filosofia e un pizzico di esoterismo, ti aspetta un'esperienza che va oltre l'ospitalità."
    },
    properties: {
      title: "Due dimore, un'unica firma",
      bb: {
        tag: "B&B · 3° piano",
        title: "B&B I Maestri",
        desc: "Quattro camere d'autore, ognuna dedicata a un grande pensiero. Colazione inclusa, lusso accessibile.",
        cta: "Le 4 camere",
        booking: "Vedi su Booking.com"
      },
      casa: {
        tag: "Casa Vacanze · 1° piano",
        title: "La Casa dei Maestri",
        desc: "Appartamento intero per famiglie e gruppi. Cucina attrezzata, soggiorno elegante, indipendenza totale.",
        cta: "Scopri la casa",
        airbnb: "Vedi su Airbnb"
      }
    },
    rooms: {
      title: "Le 4 camere del B&B",
      subtitle: "Ogni stanza prende il nome da un Maestro del pensiero. Carattere, comfort e dettagli curati.",
      cta: "Prenota questa camera",
      gallery: "Vedi galleria",
      photos: "foto",
      photoOf: "Foto",
      close: "Chiudi",
      prev: "Precedente",
      next: "Successiva",
      list: [
        { id: "platone", name: "I Maestri", quote: "\"Una vita senza ricerca non è degna per l'uomo di essere vissuta\"", author: "Platone", desc: "Camera matrimoniale con parete blu carta da zucchero, testata in mattoni a vista e accenti rossi e gialli. Bagno privato con doccia." },
        { id: "stelle", name: "Stelle", quote: "\"Il tuo compito è scoprire qual è il tuo compito e dedicartici con tutto il tuo cuore\"", author: "Buddha", desc: "Camera matrimoniale con parete blu carta da zucchero, testata in mattoni a vista e accenti gialli oro. Bagno privato con doccia." },
        { id: "vesuvio", name: "Vesuvio", quote: "\"Non esiste vento favorevole per il marinaio che non sa dove andare\"", author: "Seneca", desc: "Camera matrimoniale con parete blu carta da zucchero, testata in mattoni a vista e accenti rosso-fuoco e arancio. Atmosfera intensa e contemporanea, bagno privato con doccia e dettagli di design." },
        { id: "suite", name: "Suite", quote: "\"Non è la materia che genera il pensiero, è il pensiero che genera la materia\"", author: "Giordano Bruno", desc: "La camera più suggestiva del B&B: travi a vista, parete blu carta da zucchero scuro, panorama del Golfo di Napoli stampato sul vetro e dettagli unici. Un soggiorno fuori dall'ordinario, dedicato al filosofo nolano." }
      ]
    },
    casa: {
      title: "La Casa dei Maestri",
      subtitle: "Appartamento intero al primo piano · ideale per famiglie e gruppi fino a 4 ospiti",
      desc: "Lussuoso appartamento dal design contemporaneo, sintesi perfetta di modernità e tradizione. Situato in Via Tribunali, nel cuore vibrante del Centro Storico di Napoli, è la dimora ideale per un soggiorno rigenerante e un'esperienza unica. L'ambiente, con travi a vista e colori vivaci, presenta dettagli di design esclusivi. È stato progettato per innalzare il tuo stato emotivo, aprendoti alla scoperta delle meraviglie di questa città. Su ogni parete trovi un grande pensatore con una sua massima: un piccolo invito quotidiano al risveglio della coscienza.",
      features: ["2 camere da letto", "Fino a 4 ospiti", "Cucina attrezzata", "WiFi velocissimo", "Aria condizionata", "Lavatrice"],
      airbnb: "Vedi su Airbnb",
      direct: "Prenota direttamente (-10%)"
    },
    tours: {
      title: "Esperienze d'autore",
      subtitle: "Tour curati personalmente per i nostri ospiti. Guide locali, gruppi piccoli, niente turismo di massa.",
      list: [
        { title: "Tour esclusivo di Napoli", desc: "Scopri le meraviglie della città in un'esperienza unica! Vieni a vivere un viaggio indimenticabile tra le bellezze storiche e paesaggistiche di Napoli. Con guida in lingua, autista privato e soste nei migliori locali e attrazioni.", duration: "3 ore" },
        { title: "Costiera Amalfitana", desc: "Tour indimenticabile della Costiera Amalfitana: un viaggio tra storia, panorami mozzafiato e cultura senza tempo. Storie e aneddoti nascosti. Con guida in lingua, autista privato e soste nei migliori locali e attrazioni.", duration: "7/8 ore" },
        { title: "Costiera Sorrentina", desc: "Tour esclusivo da Napoli a Sorrento tra storia, mistero e panorami mozzafiato! Scopri i segreti nascosti di Castellammare, Vico Equense, Meta, Sant'Agnello e Sorrento. Con guida in lingua, autista privato e soste nei migliori locali e attrazioni.", duration: "7/8 ore" }
      ],
      cta: "Richiedi info sui tour"
    },
    benefits: {
      title: "Perché prenotare qui",
      subtitle: "Prenotando direttamente con noi risparmi e ottieni di più.",
      items: [
        { icon: "tag", title: "Sconto 10% garantito", desc: "Tariffa migliore rispetto a Booking e Airbnb. Sempre." },
        { icon: "heart", title: "Trattamento riservato", desc: "Welcome drink, late check-out su disponibilità, consigli personalizzati." },
        { icon: "phone", title: "Contatto diretto", desc: "Niente intermediari. Parli con noi via WhatsApp, telefono o email." },
        { icon: "map", title: "Tour su misura", desc: "Organizziamo le tue escursioni in Costiera e Napoli, scegli tu il programma." }
      ]
    },
    reviews: {
      eyebrow: "— Recensioni",
      title: "Cosa dicono i nostri ospiti",
      subtitle: "Le voci autentiche di chi ha già soggiornato da noi.",
      verified: "Recensione verificata",
      viewAllBooking: "Tutte le recensioni su Booking",
      viewAllAirbnb: "Tutte le recensioni su Airbnb"
    },
    amenities: {
      eyebrow: "— Servizi e comfort",
      title: "Tutto quello che ti aspetti. E qualcosa in più.",
      subtitle: "Dal bagno alla cucina, dalla connessione al rilassamento: ogni dettaglio è pensato per il tuo soggiorno.",
      accessibility: "Accessibilità"
    },
    cookie: {
      title: "Rispettiamo la tua privacy",
      body: "Utilizziamo solo cookie tecnici necessari al funzionamento del sito. Eventuali cookie di analisi o marketing verranno attivati solo con il tuo consenso esplicito. Leggi la nostra",
      privacyLink: "Privacy Policy",
      and: "e la",
      cookieLink: "Cookie Policy",
      accept: "Accetta tutti",
      reject: "Solo necessari",
      managePrefs: "Preferenze cookie",
      privacyTitle: "Privacy",
      close: "Chiudi"
    },
    booking: {
      title: "Richiedi disponibilità",
      subtitle: "Compila il form: riceverai conferma via email o WhatsApp entro poche ore. Sconto 10% applicato automaticamente.",
      property: "Struttura",
      bb: "B&B I Maestri",
      casa: "Casa dei Maestri",
      room: "Camera (per il B&B)",
      anyRoom: "Indifferente / Casa Vacanze",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono / WhatsApp",
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Ospiti",
      message: "Note / richieste speciali",
      submit: "Invia richiesta",
      sending: "Invio in corso...",
      success: "Richiesta ricevuta! Ti contatteremo entro poche ore.",
      error: "Errore. Riprova o scrivici su WhatsApp.",
      orCall: "oppure chiamaci direttamente",
      orWa: "scrivici su WhatsApp"
    },
    contact: {
      title: "Vieni a trovarci",
      address: "Via dei Tribunali 257, 80139 Napoli",
      floors: "B&B al 3° piano · Casa dei Maestri al 1° piano",
      phone: "Telefono",
      email: "Email",
      whatsapp: "WhatsApp"
    },
    footer: {
      tagline: "Lusso accessibile nel cuore di Napoli.",
      explore: "Esplora",
      contact: "Contatti",
      legal: "Tutti i diritti riservati.",
      direct: "Prenotazione diretta",
      partners: "Ci trovi anche su"
    }
  },
  en: {
    nav: { home: "Home", bb: "B&B", casa: "Holiday Home", tours: "Tours", contact: "Contact", book: "Book -10%" },
    hero: {
      eyebrow: "Affordable Luxury · Via dei Tribunali, Naples",
      title: "I Maestri",
      subtitle: "Two signature stays in the heart of Naples. A character-rich B&B on the 3rd floor and a refined holiday home on the 1st. Exclusive Naples and Coastal tours included.",
      cta1: "Discover the B&B",
      cta2: "The Maestri House",
      scroll: "scroll to explore"
    },
    intro: {
      label: "Our philosophy",
      title: "The luxury you expected. The price you didn't.",
      body: "Set in the beating heart of Naples, along the Decumano Maggiore, B&B I Maestri and Casa dei Maestri share the same historic palazzo at Via dei Tribunali 257. Steps away from the city's most important works of art — the Sansevero Chapel with the Veiled Christ, San Gregorio Armeno, the Duomo, Spaccanapoli — and from the world's most celebrated pizzerias and trattorias. Two distinct experiences with one shared soul: thoughtful design, modern comfort and authentic Neapolitan hospitality.",
      bodyExtra: "More than a stay: a small journey into knowledge. Every room is dedicated to a great thinker — Plato, Buddha, Seneca, Giordano Bruno — and every detail, quote and symbol invites discovery. Between art, philosophy and a touch of esotericism, an experience that goes beyond hospitality."
    },
    properties: {
      title: "Two homes, one signature",
      bb: { tag: "B&B · 3rd floor", title: "B&B I Maestri", desc: "Four character rooms, each dedicated to a great thinker. Breakfast included, affordable luxury.", cta: "The 4 rooms", booking: "View on Booking.com" },
      casa: { tag: "Holiday Home · 1st floor", title: "La Casa dei Maestri", desc: "Entire apartment for families and groups. Equipped kitchen, elegant living room, full independence.", cta: "Discover the house", airbnb: "View on Airbnb" }
    },
    rooms: {
      title: "The 4 B&B rooms",
      subtitle: "Each room is named after a Master of thought. Character, comfort and curated details.",
      cta: "Book this room",
      gallery: "View gallery",
      photos: "photos",
      photoOf: "Photo",
      close: "Close",
      prev: "Previous",
      next: "Next",
      list: [
        { id: "platone", name: "I Maestri", quote: "\"An unexamined life is not worth living\"", author: "Plato", desc: "Double room with sugar-paper blue wall, brick headboard and red & yellow accents. Private bathroom with shower." },
        { id: "stelle", name: "Stelle", quote: "\"Your task is to discover your task and devote yourself to it with all your heart\"", author: "Buddha", desc: "Double room with sugar-paper blue wall, brick headboard and golden yellow accents. Private bathroom with shower." },
        { id: "vesuvio", name: "Vesuvio", quote: "\"There is no favourable wind for the sailor who doesn't know where to go\"", author: "Seneca", desc: "Double room with sugar-paper blue wall, exposed brick headboard and fiery red and orange accents. Intense and contemporary atmosphere, private bathroom with shower and curated design details." },
        { id: "suite", name: "Suite", quote: "\"It is not matter that generates thought, but thought that generates matter\"", author: "Giordano Bruno", desc: "The most evocative room of the B&B: exposed beams, dark sugar-paper blue wall, the panorama of the Gulf of Naples printed on glass and unique design details. An out-of-the-ordinary stay, dedicated to the philosopher from Nola." }
      ]
    },
    casa: {
      title: "La Casa dei Maestri",
      subtitle: "Entire apartment on the 1st floor · ideal for families and groups up to 4 guests",
      desc: "A luxurious apartment with contemporary design, a perfect blend of modernity and tradition. Set on Via Tribunali, in the vibrant heart of Naples' historic centre, it is the ideal home for a regenerating stay and a unique experience. The space, with exposed beams and vibrant colours, features exclusive design details — crafted to lift your emotional state and open you to the wonders of this city. On every wall you'll find a great thinker with one of their maxims: a small daily invitation to the awakening of consciousness.",
      features: ["2 bedrooms", "Up to 4 guests", "Equipped kitchen", "Fast WiFi", "Air conditioning", "Washing machine"],
      airbnb: "View on Airbnb",
      direct: "Book directly (-10%)"
    },
    tours: {
      title: "Signature experiences",
      subtitle: "Tours personally curated for our guests. Local guides, small groups, no mass tourism.",
      list: [
        { title: "Exclusive Naples tour", desc: "Discover the wonders of the city in a unique experience! Live an unforgettable journey through the historic and scenic beauties of Naples. With multilingual guide, private driver and stops at the best venues and attractions.", duration: "3 hours" },
        { title: "Amalfi Coast", desc: "Unforgettable Amalfi Coast tour: a journey through history, breathtaking views and timeless culture. Hidden stories and anecdotes. With multilingual guide, private driver and stops at the best venues and attractions.", duration: "7/8 hours" },
        { title: "Sorrento Coast", desc: "Exclusive tour from Naples to Sorrento between history, mystery and breathtaking views! Discover the hidden secrets of Castellammare, Vico Equense, Meta, Sant'Agnello and Sorrento. With multilingual guide, private driver and stops at the best venues and attractions.", duration: "7/8 hours" }
      ],
      cta: "Ask about the tours"
    },
    benefits: {
      title: "Why book here",
      subtitle: "Booking directly with us saves you money and gives you more.",
      items: [
        { icon: "tag", title: "10% discount guaranteed", desc: "Better rate than Booking and Airbnb. Always." },
        { icon: "heart", title: "VIP treatment", desc: "Welcome drink, late check-out on availability, personal tips." },
        { icon: "phone", title: "Direct contact", desc: "No middlemen. Talk to us via WhatsApp, phone or email." },
        { icon: "map", title: "Custom tours", desc: "We arrange your Coastal and Naples excursions to your taste." }
      ]
    },
    reviews: {
      eyebrow: "— Reviews",
      title: "What our guests say",
      subtitle: "Authentic voices from people who have already stayed with us.",
      verified: "Verified review",
      viewAllBooking: "All reviews on Booking",
      viewAllAirbnb: "All reviews on Airbnb"
    },
    amenities: {
      eyebrow: "— Amenities & comfort",
      title: "Everything you expect. And a bit more.",
      subtitle: "From bathroom to kitchen, from connectivity to relaxation: every detail is designed for your stay.",
      accessibility: "Accessibility"
    },
    cookie: {
      title: "We respect your privacy",
      body: "We only use technical cookies necessary for the site to function. Any analytics or marketing cookies will be activated only with your explicit consent. Read our",
      privacyLink: "Privacy Policy",
      and: "and",
      cookieLink: "Cookie Policy",
      accept: "Accept all",
      reject: "Necessary only",
      managePrefs: "Cookie preferences",
      privacyTitle: "Privacy",
      close: "Close"
    },
    booking: {
      title: "Request availability",
      subtitle: "Fill in the form: you'll get a reply via email or WhatsApp within hours. 10% discount automatically applied.",
      property: "Property",
      bb: "B&B I Maestri",
      casa: "Casa dei Maestri",
      room: "Room (for the B&B)",
      anyRoom: "Any / Holiday Home",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Guests",
      message: "Notes / special requests",
      submit: "Send request",
      sending: "Sending...",
      success: "Request received! We'll contact you within hours.",
      error: "Error. Try again or write us on WhatsApp.",
      orCall: "or call us directly",
      orWa: "write us on WhatsApp"
    },
    contact: {
      title: "Come and find us",
      address: "Via dei Tribunali 257, 80139 Naples",
      floors: "B&B on the 3rd floor · Casa dei Maestri on the 1st floor",
      phone: "Phone",
      email: "Email",
      whatsapp: "WhatsApp"
    },
    footer: { tagline: "Affordable luxury in the heart of Naples.", explore: "Explore", contact: "Contact", legal: "All rights reserved.", direct: "Direct booking", partners: "Find us also on" }
  },
  fr: {
    nav: { home: "Accueil", bb: "B&B", casa: "Maison de Vacances", tours: "Tours", contact: "Contact", book: "Réserver -10%" },
    hero: {
      eyebrow: "Luxe Accessible · Via dei Tribunali, Naples",
      title: "I Maestri",
      subtitle: "Deux demeures d'auteur au cœur de Naples. Un B&B de caractère au 3ème étage et une maison de vacances raffinée au 1er. Tours exclusifs de Naples et des Côtes inclus.",
      cta1: "Découvrir le B&B",
      cta2: "La Maison des Maestri",
      scroll: "défilez pour explorer"
    },
    intro: {
      label: "Notre philosophie",
      title: "Le luxe que vous attendiez. Le prix que vous n'attendiez pas.",
      body: "Situés au cœur battant de Naples, le long du Decumano Maggiore, le B&B I Maestri et la Casa dei Maestri partagent le même palais historique de Via dei Tribunali 257. À deux pas des œuvres d'art les plus importantes de la ville — la Chapelle Sansevero avec le Christ Voilé, San Gregorio Armeno, le Duomo, Spaccanapoli — et des pizzerias et trattorias les plus célèbres au monde. Deux expériences différentes avec la même âme : design soigné, confort moderne et accueil napolitain authentique.",
      bodyExtra: "Plus qu'un séjour : un petit voyage dans la connaissance. Chaque chambre est dédiée à un grand penseur — Platon, Bouddha, Sénèque, Giordano Bruno — et chaque détail, citation et symbole invite à la découverte. Entre art, philosophie et une touche d'ésotérisme, une expérience qui va au-delà de l'hospitalité."
    },
    properties: {
      title: "Deux demeures, une signature",
      bb: { tag: "B&B · 3ème étage", title: "B&B I Maestri", desc: "Quatre chambres d'auteur, chacune dédiée à un grand penseur. Petit-déjeuner inclus, luxe accessible.", cta: "Les 4 chambres", booking: "Voir sur Booking.com" },
      casa: { tag: "Maison de Vacances · 1er étage", title: "La Casa dei Maestri", desc: "Appartement entier pour familles et groupes. Cuisine équipée, salon élégant, indépendance totale.", cta: "Découvrir la maison", airbnb: "Voir sur Airbnb" }
    },
    rooms: {
      title: "Les 4 chambres du B&B",
      subtitle: "Chaque chambre porte le nom d'un Maître de la pensée. Caractère, confort et détails soignés.",
      cta: "Réserver cette chambre",
      gallery: "Voir la galerie",
      photos: "photos",
      photoOf: "Photo",
      close: "Fermer",
      prev: "Précédente",
      next: "Suivante",
      list: [
        { id: "platone", name: "I Maestri", quote: "\"Une vie sans recherche ne mérite pas d'être vécue\"", author: "Platon", desc: "Chambre double avec mur bleu carta-zucchero, tête de lit en briques et accents rouges et jaunes. Salle de bain privée avec douche." },
        { id: "stelle", name: "Stelle", quote: "\"Ta tâche est de découvrir quelle est ta tâche et de t'y consacrer de tout ton cœur\"", author: "Buddha", desc: "Chambre double avec mur bleu carta-zucchero, tête de lit en briques et accents jaune doré. Salle de bain privée avec douche." },
        { id: "vesuvio", name: "Vesuvio", quote: "\"Il n'existe pas de vent favorable pour le marin qui ne sait pas où il va\"", author: "Sénèque", desc: "Chambre double avec mur bleu carta-zucchero, tête de lit en briques apparentes et accents rouge-feu et orange. Atmosphère intense et contemporaine, salle de bain privée avec douche et détails de design soignés." },
        { id: "suite", name: "Suite", quote: "\"Ce n'est pas la matière qui engendre la pensée, mais la pensée qui engendre la matière\"", author: "Giordano Bruno", desc: "La chambre la plus évocatrice du B&B : poutres apparentes, mur bleu carta-zucchero foncé, panorama du Golfe de Naples imprimé sur le verre et détails uniques. Un séjour hors du commun, dédié au philosophe de Nola." }
      ]
    },
    casa: {
      title: "La Casa dei Maestri",
      subtitle: "Appartement entier au 1er étage · idéal pour familles et groupes jusqu'à 4 personnes",
      desc: "Un appartement luxueux au design contemporain, synthèse parfaite entre modernité et tradition. Situé Via Tribunali, au cœur vibrant du Centre Historique de Naples, c'est la demeure idéale pour un séjour régénérant et une expérience unique. L'espace, avec ses poutres apparentes et ses couleurs vives, présente des détails de design exclusifs — pensé pour élever votre état émotionnel et vous ouvrir aux merveilles de cette ville. Sur chaque mur vous trouverez un grand penseur avec l'une de ses maximes : une petite invitation quotidienne à l'éveil de la conscience.",
      features: ["2 chambres", "Jusqu'à 4 personnes", "Cuisine équipée", "WiFi rapide", "Climatisation", "Machine à laver"],
      airbnb: "Voir sur Airbnb",
      direct: "Réservez en direct (-10%)"
    },
    tours: {
      title: "Expériences d'auteur",
      subtitle: "Tours personnellement organisés pour nos clients. Guides locaux, petits groupes, pas de tourisme de masse.",
      list: [
        { title: "Tour exclusif de Naples", desc: "Découvrez les merveilles de la ville dans une expérience unique ! Vivez un voyage inoubliable parmi les beautés historiques et paysagères de Naples. Avec guide en langue, chauffeur privé et arrêts dans les meilleurs lieux et attractions.", duration: "3 heures" },
        { title: "Côte Amalfitaine", desc: "Tour inoubliable de la Côte Amalfitaine : un voyage entre histoire, panoramas à couper le souffle et culture intemporelle. Histoires et anecdotes cachées. Avec guide en langue, chauffeur privé et arrêts dans les meilleurs lieux et attractions.", duration: "7/8 heures" },
        { title: "Côte de Sorrente", desc: "Tour exclusif de Naples à Sorrente entre histoire, mystère et panoramas à couper le souffle ! Découvrez les secrets cachés de Castellammare, Vico Equense, Meta, Sant'Agnello et Sorrente. Avec guide en langue, chauffeur privé et arrêts dans les meilleurs lieux et attractions.", duration: "7/8 heures" }
      ],
      cta: "Demandez infos sur les tours"
    },
    benefits: {
      title: "Pourquoi réserver ici",
      subtitle: "Réserver directement avec nous vous fait économiser et vous offre plus.",
      items: [
        { icon: "tag", title: "10% de réduction garantie", desc: "Meilleur tarif que Booking et Airbnb. Toujours." },
        { icon: "heart", title: "Traitement VIP", desc: "Welcome drink, late check-out selon dispo, conseils personnalisés." },
        { icon: "phone", title: "Contact direct", desc: "Aucun intermédiaire. Parlez avec nous via WhatsApp, téléphone ou email." },
        { icon: "map", title: "Tours sur mesure", desc: "Nous organisons vos excursions sur les Côtes et à Naples selon vos envies." }
      ]
    },
    reviews: {
      eyebrow: "— Avis",
      title: "Ce que disent nos hôtes",
      subtitle: "Les voix authentiques de ceux qui ont déjà séjourné chez nous.",
      verified: "Avis vérifié",
      viewAllBooking: "Tous les avis sur Booking",
      viewAllAirbnb: "Tous les avis sur Airbnb"
    },
    amenities: {
      eyebrow: "— Services & confort",
      title: "Tout ce que vous attendez. Et un peu plus.",
      subtitle: "De la salle de bain à la cuisine, de la connexion à la détente : chaque détail est pensé pour votre séjour.",
      accessibility: "Accessibilité"
    },
    cookie: {
      title: "Nous respectons votre vie privée",
      body: "Nous n'utilisons que des cookies techniques nécessaires au fonctionnement du site. Les cookies d'analyse ou de marketing ne seront activés qu'avec votre consentement explicite. Consultez notre",
      privacyLink: "Politique de Confidentialité",
      and: "et la",
      cookieLink: "Politique Cookies",
      accept: "Tout accepter",
      reject: "Uniquement nécessaires",
      managePrefs: "Préférences cookies",
      privacyTitle: "Confidentialité",
      close: "Fermer"
    },
    booking: {
      title: "Demander disponibilité",
      subtitle: "Remplissez le formulaire : réponse par email ou WhatsApp en quelques heures. Réduction de 10% appliquée automatiquement.",
      property: "Structure",
      bb: "B&B I Maestri",
      casa: "Casa dei Maestri",
      room: "Chambre (pour le B&B)",
      anyRoom: "Indifférent / Maison de Vacances",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone / WhatsApp",
      checkin: "Arrivée",
      checkout: "Départ",
      guests: "Voyageurs",
      message: "Notes / demandes spéciales",
      submit: "Envoyer la demande",
      sending: "Envoi en cours...",
      success: "Demande reçue ! Nous vous contacterons sous peu.",
      error: "Erreur. Réessayez ou écrivez-nous sur WhatsApp.",
      orCall: "ou appelez-nous directement",
      orWa: "écrivez-nous sur WhatsApp"
    },
    contact: {
      title: "Venez nous trouver",
      address: "Via dei Tribunali 257, 80139 Naples",
      floors: "B&B au 3ème étage · Casa dei Maestri au 1er étage",
      phone: "Téléphone",
      email: "Email",
      whatsapp: "WhatsApp"
    },
    footer: { tagline: "Luxe accessible au cœur de Naples.", explore: "Explorer", contact: "Contact", legal: "Tous droits réservés.", direct: "Réservation directe", partners: "Retrouvez-nous aussi sur" }
  }
};

export const LANGUAGES = [
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" }
];
